import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';
import { blueGrey } from '@mui/material/colors';
import { TEXT_PRIMARY } from '../app.styles';

export const StyledButton = styled(Button)<ButtonProps<'a'>>({
  fontWeight: 400,
  textTransform: 'uppercase',
  backgroundColor: TEXT_PRIMARY,
  '&:hover': {
    backgroundColor: blueGrey[600],
  },
  fontFamily: 'Silka, sans-serif',
  letterSpacing: '0.03rem',
});
